import script from "./MilageTextEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./MilageTextEditor.vue?vue&type=script&setup=true&lang=ts"

import "./MilageTextEditor.vue?vue&type=style&index=0&id=4de2227d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de2227d"]])

export default __exports__